import { IndexedDbData } from '../models/indexedDB-model';
import { CaptureImageData } from '../models/captureImage-model';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  public called: boolean = false;
  data: any = {
    order: '',
    action: '',
  };
  public editDataDetails: any = [];
  public action!: string;
  private scanDataResult!: string;
  private shareImg!: CaptureImageData;
  private shareIndexedDBData!: IndexedDbData;
  private zeitTotal!: boolean;
  private messageSource = new BehaviorSubject(this.data);
  private imageSource = new BehaviorSubject(this.shareImg);
  private indexDBSource = new BehaviorSubject(this.shareIndexedDBData);
  private zeitTotalSource = new BehaviorSubject(this.zeitTotal);
  private scanData = new BehaviorSubject(this.scanDataResult);
  currentMessage = this.messageSource.asObservable();
  currentImage = this.imageSource.asObservable();
  currentIndexDB = this.indexDBSource.asObservable();
  currentZeitTotal = this.zeitTotalSource.asObservable();
  currentScanData = this.scanData.asObservable();

  constructor() {}

  changeMessage(message: any, action: string) {
    this.called = true;
    this.data = {
      order: message!,
      action: action,
    };
    this.messageSource.next(this.data);
  }

  scannedData(data: string) {
    this.scanData.next(data);
  }

  shareZeitTotal(value: boolean) {
    this.zeitTotalSource.next(value);
  }

  shareImage(img: CaptureImageData) {
    this.imageSource.next(img);
  }

  shareIndexedDB(db: IndexedDbData) {
    this.indexDBSource.next(db);
  }
}
